import React from "react";
import styles from "./summary-list.module.css";
import { useDoubt } from "../../../context/DoubtContext";
import { renderContent } from "../../../utils/TutorConstants";
import { useRoot } from "../../../context/RootContext";
import EmptyPocketImg from "../../../assets/ai-tutor/emptyPocket.svg";
import { isEmptyOrNull, isNotEmptyOrNull } from "../../../utils/common-utils";

const SummaryList = () => {
  const {
    summaryList,
    setSelectedSummary,
    setUserChat,
    chatId,
    setMediaDetails,
    getConversationMedia
  } = useDoubt();
  const { toggleDoubtDrawer } = useRoot();

  const handleSummaryClick = (item) => {
    toggleDoubtDrawer();
    setMediaDetails([]);
    setUserChat([]);
    setSelectedSummary(item);
    getConversationMedia(item.chat_uuid);
  };
  return (
    <div className={styles["container"]}>
      {isNotEmptyOrNull(summaryList) ?
      summaryList?.
      filter((item) => item.chat_uuid !== chatId)?.
      map((item, index) =>
      <div
        key={item?.chat_uuid || index}
        className={styles["query-container"]}
        onClick={() => handleSummaryClick(item)}>

              <div className={styles["query-qicon"]}>Q.</div>
              <div className={styles["query-text"]}>
                {renderContent(isEmptyOrNull(item?.selected_query) ? item?.query : item?.selected_query, true)}
              </div>
            </div>
      ) :

      <div className={styles["emptySummary"]}>
          <img src={EmptyPocketImg} />
          <div className={styles["emptySummaryTitle"]}>
            Your Pocket is empty
          </div>
          <div className={styles["emptySummaryDescription"]}>
            Send conversations to pocket to get started
          </div>
        </div>
      }
    </div>);

};

export default React.memo(SummaryList);